import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { CandidateDetail } from './components/CandidateDetail';

export const CandidateDetailPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const imageId = searchParams.get('image_id');

  return <CandidateDetail key={imageId} />;
};

export default CandidateDetailPage;
